module.exports = __webpack_public_path__ + "static/media/small.8f12eb68.svg";